import React from 'react'
import Button from '../../components/atoms/Button';

export default ({ titleSuccess, contentSuccess, closeSuccess }) => {
	return (
		<div className='kc-modal-dialog'>
			<button type="button" className="kc-modal-close" onClick={closeSuccess}>
				<span aria-hidden="true">&times;</span>
			</button>
			
			<div className='kc-modal-content'>
				<img className='icon' src={'/img/icon/Berhasil.png'} alt='' />
				<h1>{titleSuccess}</h1>
				<p className='resize-margin-p'>{contentSuccess}</p>
				<div className='kc-modal-button'>
					<Button type='button' title={'TUTUP'} color="outline" width="big-rounded" onClick={closeSuccess} />
				</div>
			</div>
		</div>
	)
}